/**
 * BJAF PDP reel video modal ("See it in action" cards).
 * Cards + video sources are rendered by snippets/bjaf-pdp-reel.liquid; this only
 * wires up the click-to-play behavior. No-ops entirely if the modal isn't on the page.
 */
(function () {
  'use strict';

  var modal = document.getElementById('reelVideoModal');
  if (!modal) {
    return;
  }

  // Move the modal to be a direct child of <body>. Left in place, it inherits
  // whatever stacking context its section/gallery ancestors create, which let the
  // sticky header and gallery arrows render on top of it despite the high z-index.
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var videoEl = modal.querySelector('.bjaf-reel-modal__video');
  var lastFocus = null;
  var lockY = 0;
  var inertedSiblings = [];

  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])';

  function getFocusable() {
    return Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
      return el.offsetParent !== null || el === videoEl;
    });
  }

  // Screen readers and Tab order should treat everything behind the modal as if
  // it doesn't exist while it's open, not just visually hidden under an overlay.
  function setBackgroundInert(isInert) {
    if (isInert) {
      inertedSiblings = Array.prototype.slice.call(document.body.children).filter(function (el) {
        return el !== modal && !el.hasAttribute('inert');
      });
      inertedSiblings.forEach(function (el) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
      });
    } else {
      inertedSiblings.forEach(function (el) {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      });
      inertedSiblings = [];
    }
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || modal.hidden) {
      return;
    }
    var focusable = getFocusable();
    if (!focusable.length) {
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function loadSources(videoId) {
    var template = document.querySelector('[data-reel-video-source="' + videoId + '"]');
    videoEl.innerHTML = '';
    if (template) {
      videoEl.appendChild(template.content.cloneNode(true));
    }
    videoEl.load();
  }

  function openModal(trigger) {
    var videoId = trigger.getAttribute('data-video-id');
    if (!videoId) {
      return;
    }

    loadSources(videoId);

    lastFocus = trigger;
    modal.hidden = false;
    setBackgroundInert(true);
    lockY = window.scrollY || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';

    window.requestAnimationFrame(function () {
      modal.classList.add('in');
      videoEl.play().catch(function () {
        /* Autoplay can be blocked; controls are visible so the shopper can hit play. */
      });
    });

    var closeButton = modal.querySelector('.bjaf-reel-modal__close');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    modal.classList.remove('in');
    videoEl.pause();
    setBackgroundInert(false);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, lockY);

    var done = function () {
      modal.hidden = true;
      videoEl.removeAttribute('src');
      videoEl.innerHTML = '';
      modal.removeEventListener('transitionend', done);
    };

    modal.addEventListener('transitionend', done);
    window.setTimeout(function () {
      if (!modal.hidden) {
        done();
      }
    }, 400);

    if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-reel-video-trigger]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (event.target.closest('[data-close]') && !modal.hidden) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
      return;
    }
    trapFocus(event);
  });
})();
